import Axios from 'axios';

import * as types from './types';
import { host } from "../host";
import {
    addLoading,
    removeLoading,
} from "./commonAction";
import catchErrorApi from '../helper/catchErrorApi';

const apiCreateOffice = host + "admin/office/create";
const apiFilterOffice = host + "admin/office/filter";
const apiUpdateOffice = host + "admin/office/update";
const apiDeleteOffice = host + "admin/office/delete";
const apiGetBranch = host + "admin/office/get-branch";

/**
 * 
 * @param {String} name name of office
 * @param {String} address full address of office
 * @param {String} province province of office
 * @param {String} branchCode type of office
 * @param {String} district district of office
 * @param {string} ward ward of office
 * @param {"HEAD" \| "TRADING" \| "BRANCH"} officeType type of office
 * @param {Object} deviceConfig: {
 *    @param {boolean} hasKioskDeviceConfig
 *    @param {boolean} hasTabletDeviceConfig
 *    @param {boolean} hasLcdDeviceConfig
 * }
 */
export const createOffice = (dataCreate, callbackFunc) => async dispatch => {
    const queryFormatData = JSON.stringify({
        ...dataCreate
    })
    try {
        const res = await Axios.post(apiCreateOffice, queryFormatData);
        const { data } = res;
        dispatch({
            type: types.CREATE_NEW_OFFICE,
            success: Boolean(data)
        })
    }
    catch (err) {
        const handleError400 = () => {
            if (err.response.data.Code === 5) {
                dispatch({
                    type: types.CREATE_NEW_OFFICE_ERR,
                    err: err.response.data,
                })
                return true;
            }
            const { Code } = err.response.data
            callbackFunc(Code)
            return true;
        }
        catchErrorApi(err, dispatch, types.CREATE_NEW_OFFICE_ERR, handleError400)
    }
}

/**
 * 
 * @param {{
 *  name: string, 
 *  address: string, 
 *  province: string, 
 *  district: string, 
 *  ward: string,
 *  officeType: "HEAD" \| "TRADING" \| "BRANCH"
 *  deviceConfig: {
 *    hasKioskDeviceConfig: bool,
 *    hasTabletDeviceConfig: bool,
 *    hasLcdDeviceConfig: bool
 *  }
 *  hasFilterDevicesConfig: bool
 * }} dataFilter 
 * @param {number} pageSize 
 * @param {number} pageNumber 
 */

export const clearFilterOffice = () => ({
    type: types.CLEAR_FILTER_OFFICE
})

export const filterOffice = (dataFilter, pageSize, pageNumber) => async dispatch => {
    dispatch(addLoading())
    //---
    let hasFilterDevicesConfig = false;
    const formatDataFilter = {};
    if (dataFilter !== undefined && dataFilter !== null && Object.keys(dataFilter).length !== 0) {
        if (dataFilter.name) formatDataFilter["Name"] = dataFilter.name.trim();
        if (dataFilter.adress) formatDataFilter["Address"] = dataFilter.adress;
        if (dataFilter.province) formatDataFilter["Province"] = dataFilter.province;
        if (dataFilter.district) formatDataFilter["District"] = dataFilter.district;
        if (dataFilter.ward) formatDataFilter["Ward"] = dataFilter.ward;
        if (dataFilter.officeType) formatDataFilter["OfficeType"] = dataFilter.officeType;
        if (dataFilter.deviceConfig != null && Object.keys(dataFilter.deviceConfig).length !== 0) {
            formatDataFilter["HasKioskDeviceConfig"] = dataFilter.deviceConfig.hasKioskDeviceConfig ?? false
            formatDataFilter["HasLcdDeviceConfig"] = dataFilter.deviceConfig.hasLcdDeviceConfig ?? false
            formatDataFilter["HasTabletDeviceConfig"] = dataFilter.deviceConfig.hasTabletDeviceConfig ?? false
        }
        //---
        hasFilterDevicesConfig = dataFilter.hasFilterDevicesConfig ?? false;
    }

    const queryFormatData = JSON.stringify({
        ...formatDataFilter,
        PageSize: pageSize,
        PageNumber: pageNumber,
        HasFilterDevicesConfig: hasFilterDevicesConfig
    })

    try {
        const res = await Axios.post(apiFilterOffice, queryFormatData);
        const { data } = res;
        dispatch({
            type: types.FILTER_OFFICE,
            listOffice: data.ListOffice ? data.ListOffice : [],
            total: data.Total,
            dataFilter
        })
        dispatch(removeLoading())
    }
    catch (err) {
        dispatch(removeLoading())

        catchErrorApi(
            err,
            dispatch,
            types.FILTER_OFFICE_ERR,
            () => false
        )
    }
}

export const handerSearchByNameOrOfficeType = (dataFilter, pageSize, pageNumber) => async dispatch => {
    dispatch(addLoading())
    //---
    const formatDataFilter = {};
    if (dataFilter !== undefined && dataFilter !== null && Object.keys(dataFilter).length !== 0) {
        if (dataFilter.name) formatDataFilter["Name"] = dataFilter.name.trim();
        if (dataFilter.officeType) formatDataFilter["OfficeType"] = dataFilter.officeType;
    }

    const queryFormatData = JSON.stringify({
        ...formatDataFilter,
        PageSize: pageSize,
        PageNumber: pageNumber
    })

    try {
        const res = await Axios.post(apiFilterOffice, queryFormatData);

        const { data } = res;
        dispatch({
            type: types.FILTER_OFFICE,
            listOffice: data.ListOffice ? data.ListOffice : [],
            total: data.Total,
            dataFilter
        })
        dispatch(removeLoading())
    }
    catch (err) {
        dispatch(removeLoading())

        catchErrorApi(
            err,
            dispatch,
            types.FILTER_OFFICE_ERR,
            () => false
        )
    }
}

export const getAllOfficeV2 = () => async dispatch => {
    dispatch(addLoading())
    try {
        const all = await Axios.post(
            apiFilterOffice,
            JSON.stringify({
                PageSize: 1000000,
                PageNumber: 1
            })
        );
        dispatch({
            type: types.GET_ALL_OFFICE,
            allOfficeList: all.data.ListOffice ? all.data.ListOffice : [],
            total: all.data.Total,
            dataFilter: {}
        })
    }
    catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_ALL_OFFICE_ERR,
            () => false
        )
    }
    dispatch(removeLoading())
}

export const getAllBranch = (UID) => async dispatch => {
    const queryDataFormat = JSON.stringify({
        UID: UID
    })
    try {
        const res = await Axios.post(apiGetBranch, queryDataFormat)
        const { data } = res
        dispatch({
            type: types.GET_ALL_BRANCH,
            allBranchList: data.ListBranch ? data.ListBranch : [],
        })
    }
    catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_ALL_BRANCH_ERR,
            () => false
        )
    }
}
/**
 * 
 * @param {{
 * ID*: string,
 * Name:  string,
 * Address: string,
 * Province: string,
 * District: string,
 * Ward: string,
 * OfficeType: "HEAD" \| "TRADING" \| "BRANCH"
 * HasKioskDeviceConfig: bool,
 * HasTabletDeviceConfig: bool,
 * HasLcdDeviceConfig: bool
 * }} dataUpdate 
 */
export const updateOffice = (dataUpdate, callbackFunc) => async dispatch => {
    const queryFormatData = JSON.stringify({
        ...dataUpdate
    })

    try {
        const res = await Axios.post(apiUpdateOffice, queryFormatData);
        const { data } = res;
        //---
        callbackFunc(data.Code)
    }
    catch (err) {
        const handleError400 = () => {
            const { Code } = err.response.data
            callbackFunc(Code)
            return true
        }
        catchErrorApi(err, dispatch, types.UPDATE_OFFICE_ERR, handleError400)
    }
}

/**
 * 
 * @param {string} idOffice 
 */
export const deleteOffice = (idOffice) => async dispatch => {
    const dataQueryFormat = JSON.stringify({
        ID: idOffice
    });

    try {
        const res = await Axios.post(apiDeleteOffice, dataQueryFormat);
        const { data } = res;

        dispatch({
            type: types.DELETE_OFFICE,
            success: data.Code === 0
        })
    }
    catch (err) {
        const handleError400 = () => {
            if (err.response.data.Code === 5) {
                dispatch({
                    type: types.DELETE_OFFICE_ERR,
                    err: err.response.data
                })
                return true;
            }
            return false;
        }

        catchErrorApi(
            err,
            dispatch,
            types.DELETE_OFFICE_ERR,
            handleError400
        )
    }
}

export const clearErrorDeleteOffice = () => ({
    type: types.CLEAR_ERR_DELETE_OFFICE
})

export const resetStateOffice = () => (
    {
        type: types.RESET_STATE_OFFICE
    }
)

export const alertFillterOffice = () => {
    return {
        type: types.ALERT_CONTENT
    }
}


export const saveTextSearchOffice = text => ({
    type: types.SAVE_TEXT_OFFICE,
    textSearch: text
})

export const clearTextSearchOffice = () => ({
    type: types.CLEAR_TEXT_OFFICE,
})